var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1114",
    "data-name": "Group 1114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.074,
    height: 18.07,
    viewBox: "0 0 20.074 18.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 20.074,
    height: 18.07,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1114-2",
    "data-name": "Group 1114",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M11.316,16.062H8.341c-.7,1.592-1.538,2.132-2.746,1.79A2.1,2.1,0,0,1,4.18,15.33c-.261-.114-.535-.231-.805-.353A8.337,8.337,0,0,1,.281,12.566a1.007,1.007,0,0,1-.2-1.093,1.089,1.089,0,0,1,.965-.657c.943-.1,1.135-.219,1.315-1.163s.227-1.908.365-2.858A7.419,7.419,0,0,1,6.61,1.265,9.27,9.27,0,0,1,17.42,2.319c4.082,3.6,3.352,9.8-1.485,12.61l-.5.286c.136,1.69-.435,2.608-1.74,2.827-1.106.185-2.025-.569-2.382-1.98m-10.248-4.2a7.441,7.441,0,0,0,3.544,2.481.688.688,0,0,0,.469-.116,2.126,2.126,0,0,1,2.76.452.942.942,0,0,0,.6.3q1.364.049,2.731,0a.931.931,0,0,0,.608-.291,2.094,2.094,0,0,1,2.784-.5.586.586,0,0,0,.468.04A6.667,6.667,0,0,0,18.115,4.8,8.1,8.1,0,0,0,6.456,2.624,6.158,6.158,0,0,0,3.732,7.094c-.088.851-.15,1.706-.285,2.55a2.293,2.293,0,0,1-1.594,2.078,7.5,7.5,0,0,1-.784.141",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M75.408,82.093a3.642,3.642,0,0,1-3.441-2.3c-.139-.367-.187-.728.252-.9.419-.16.594.132.734.482A2.473,2.473,0,0,0,75.3,81.02a2.671,2.671,0,0,0,2.66-1.432c.052-.093.063-.243.138-.282a5.91,5.91,0,0,1,.675-.264c.084.225.288.489.231.67A3.189,3.189,0,0,1,76.81,81.8a11.959,11.959,0,0,1-1.4.294",
    transform: "translate(-64.139 -70.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M74.41,48.5a1.063,1.063,0,0,1,1.034,1.125,1.014,1.014,0,0,1-1.063.971,1.037,1.037,0,0,1-1.042-1.059A1.062,1.062,0,0,1,74.41,48.5",
    transform: "translate(-65.451 -43.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M118.164,48.5a1.058,1.058,0,0,1,1.04,1.065A1.023,1.023,0,0,1,118.14,50.6a1.039,1.039,0,0,1-1.047-1.054,1.064,1.064,0,0,1,1.072-1.038",
    transform: "translate(-104.498 -43.287)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/waze.d88d41148cf342155dca4aec74e387e5.svg";
export { ForwardRef as ReactComponent };